import { callable } from './callable'
import type {
  GetPlantDowntimeReportInput,
  GetPlantDowntimeReportResult,
} from '../types/ops'

export async function getPlantDowntimeReport(
  input: GetPlantDowntimeReportInput,
): Promise<GetPlantDowntimeReportResult> {
  return callable<GetPlantDowntimeReportInput, GetPlantDowntimeReportResult>(
    'getPlantDowntimeReport',
    input,
  )
}

export function formatDowntimeDuration(minutes: number): string {
  if (minutes < 60) {
    return `${minutes} m`
  }
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (m === 0) {
    return `${h} h`
  }
  return `${h} h ${m.toString().padStart(2, '0')} m`
}

export function generatePlantDowntimeCsv(report: GetPlantDowntimeReportResult): string {
  const headers = [
    'Machine',
    'Asset Code',
    'Line',
    'Downtime Reason',
    'Note',
    'Down Since',
    'Released At',
    'Downtime Minutes',
    'Status',
  ]
  const rows = report.items.map((item) => [
    `"${(item.machineName || '').replace(/"/g, '""')}"`,
    `"${(item.assetCode || '').replace(/"/g, '""')}"`,
    `"${(item.lineName || '').replace(/"/g, '""')}"`,
    `"${(item.downtimeReason || '').replace(/"/g, '""')}"`,
    `"${(item.downtimeNote || '').replace(/"/g, '""')}"`,
    new Date(item.downSince).toISOString(),
    item.releasedAt ? new Date(item.releasedAt).toISOString() : '',
    String(item.downtimeMinutes),
    item.isOpen ? 'Open' : 'Resolved',
  ])
  return [headers.join(','), ...rows.map((r) => r.join(','))].join('\n')
}
